module.exports = __webpack_public_path__ + "560ef9455474b17989778a84b7e51163.jpg";